interface CurrentTimeIndicatorProps {
  /** Index of the today column. -1 means today is not in the visible window. */
  todayIndex: number;
  /** Pixel width of each day column. */
  dayWidth: number;
  /** Pixel offset from the left edge of the items area (after the label column). */
  leftOffset: number;
}

/**
 * "Today" column highlight, Toggl Plan style: a soft orange tint covering
 * the WHOLE column (from below the header to the bottom of the timeline).
 *
 * Rendered inside the root overlay (which spans top: headerHeight →
 * bottom: 0), so stretching is just `top-0 bottom-0` — no height math.
 * Rendered only when `todayIndex >= 0`.
 */
export function CurrentTimeIndicator({
  todayIndex,
  dayWidth,
  leftOffset,
}: CurrentTimeIndicatorProps) {
  if (todayIndex < 0) return null;

  const columnLeft = leftOffset + todayIndex * dayWidth;

  return (
    <div
      aria-hidden
      data-testid="timeline-today-highlight"
      className="pointer-events-none absolute top-0 bottom-0 bg-orange-400/10"
      style={{ left: columnLeft, width: dayWidth }}
    />
  );
}
